export default __webpack_public_path__ + "static/soccer-956eda5f39ce07945194ed0897b5ca09.svg";